import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dropdown, MenuProps } from 'antd';
import { setStoredLanguage } from 'utils/languagePreference';

const LanguageSwitcher: React.FC = () => {
    const { t, i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState<string>(
        i18n.resolvedLanguage || i18n.language || 'en'
    );

    useEffect(() => {
        const updateLanguage = () => {
            const lang = i18n.resolvedLanguage || i18n.language || 'en';
            setCurrentLang(lang);
        };

        i18n.on('languageChanged', updateLanguage);
        updateLanguage();

        return () => {
            i18n.off('languageChanged', updateLanguage);
        };
    }, [i18n]);

    const getLanguageDisplay = () => {
        const normalizedLang = currentLang.toLowerCase().split('-')[0];
        switch (normalizedLang) {
            case 'zh': return '中';
            case 'es': return 'Es';
            default: return 'En';
        }
    };

    const changeLanguage = (lng: string) => {
        setStoredLanguage(lng);
        i18n.changeLanguage(lng)
            .then(() => {
                window.location.reload();
            })
            .catch((err: Error) => {
                console.error('Error changing language:', err);
            });
    };

    const languageItems: MenuProps['items'] = [
        { key: 'en', label: t('preferences.language.options.en') },
        { key: 'zh', label: t('preferences.language.options.zh') },
        { key: 'es', label: t('preferences.language.options.es') },
    ];

    const handleLanguageChange: MenuProps['onClick'] = (e) => {
        changeLanguage(e.key);
    };

    return (
        <Dropdown
            menu={{ items: languageItems, onClick: handleLanguageChange }}
            placement="bottomRight"
            arrow
        >
            <div className="flex items-center cursor-pointer">
                <Button type="default" shape="circle">
                    {getLanguageDisplay()}
                </Button>
            </div>
        </Dropdown>
    );
};

export default LanguageSwitcher;
